<template functional>
  <div>
    <a
      v-if="props.rowValue > 0 && props.row.Rojo == null"
      href="#"
      @click="$options.show(props)"
      class="AzulAuto"
    >
      {{ props.rowValue }}
    </a>
    <a
      v-if="props.rowValue > 0 && props.row.Rojo != null"
      href="#"
      @click="$options.show(props)"
      :class="[
        $options.monthName[props.row.Rojo].Name == props.column
          ? 'RojoAuto'
          : 'AzulAuto'
      ]"
    >
      {{ props.rowValue }}
    </a>
  </div>
</template>

<script>
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperLinkForAutoMvReport",
  monthName: {
    1: { Name: "Enero" },
    2: { Name: "Febrero" },
    3: { Name: "Marzo" },
    4: { Name: "Abril" },
    5: { Name: "Mayo" },
    6: { Name: "Junio" },
    7: { Name: "Julio" },
    8: { Name: "Agosto" },
    9: { Name: "Septiembre" },
    10: { Name: "Octubre" },
    11: { Name: "Noviembre" },
    12: { Name: "Diciembre" }
  },
  show(ops) {
    ops;
    //console.log("hola", ops);
    // ops.row.OpenDetailDataCliente(ops.row);
    ops.row.OpenDetailAutoMV(ops.row, ops.column);
  }
};
</script>
<!-- class="AzulAuto" -->
<!-- :class="[props.row.RojoAuto ? 'RojoAuto' : 'AzulAuto']" -->

<style scoped>
.RojoAuto {
  width: 2rem;
  height: 2rem;
  color: #c71d10;
  background-color: rgba(234, 22, 22, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}
.AzulAuto {
  width: 2rem;
  height: 2rem;
  color: blue;
  background-color: rgba(25, 133, 187, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 3%;
}
</style>
